import { PlusOutlined } from '@ant-design/icons'
import type { ResidentItem } from '@lmc/ts-common'
import { Button } from '@lmc/ui-kit'
import { Tooltip } from 'antd'
import { NAMESPACE } from 'locale'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'
import { useAddMedicationButtonState } from '../hooks/useAddMedicationButtonState'

type AddMedicationResident = Pick<
  ResidentItem,
  'status' | 'isActiveInitialAssessment'
>

type AddMedicationButtonProps = {
  resident?: AddMedicationResident
  onClick: () => void
  dataTestId?: string
  style?: CSSProperties
}

export const AddMedicationButton = ({
  resident,
  onClick,
  dataTestId,
  style
}: AddMedicationButtonProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const { disabled, tooltip } = useAddMedicationButtonState(resident)

  const button = (
    <Button
      id="add-medication-button"
      onClick={onClick}
      variant="primary"
      disabled={disabled}
      style={style}
      data-testid={dataTestId}
    >
      <PlusOutlined />
      {t('ADD_MEDICATION')}
    </Button>
  )

  if (!tooltip) return button

  // A natively disabled <button> doesn't dispatch mouse events, so antd's
  // Tooltip never sees a hover — wrap it in a span so the span is what
  // actually receives the hover and triggers the tooltip.
  return (
    <Tooltip title={tooltip} placement="bottom">
      <span>{button}</span>
    </Tooltip>
  )
}
